import "./css/for_students_parents_teachers_schools.css"

const ForStudentsParentsTeachersSchools = ({ why_key, icon_url, heading, content, make_green }) => {
  return (
    <div className={`for_container${make_green ? " make_green" : ""}`}>
      <h3>
        <img src={icon_url} alt={icon_url} />
        <span>{heading}</span>
      </h3>
      {content.length > 0 && (
        <ul>
          {content.map((li_item, index) => (
            <li key={index}>{li_item}</li>
          ))}
        </ul>
        )}
    </div>
  );
};

export default ForStudentsParentsTeachersSchools;
